import { Form } from 'react-router'
import { z } from 'zod'
import { Icon } from '#app/components/atoms'
import { StatusButton } from '#app/components/molecules'
import { useIsPending } from './misc.tsx'

export const FACEBOOK_PROVIDER_NAME = 'facebook'
// to add another provider, set their name here and add it to the providerNames below

export const GITHUB_PROVIDER_NAME = 'github'
// to add another provider, set their name here and add it to the providerNames below

export const GOOGLE_PROVIDER_NAME = 'google'
// to add another provider, set their name here and add it to the providerNames below

export const providerNames = [
	FACEBOOK_PROVIDER_NAME,
	GITHUB_PROVIDER_NAME,
	GOOGLE_PROVIDER_NAME,
] as const
export const ProviderNameSchema = z.enum(providerNames)
export type ProviderName = z.infer<typeof ProviderNameSchema>

export const providerLabels: Record<ProviderName, string> = {
	[FACEBOOK_PROVIDER_NAME]: 'Facebook',
	[GITHUB_PROVIDER_NAME]: 'GitHub',
	[GOOGLE_PROVIDER_NAME]: 'Google',
} as const

export const providerIcons: Record<ProviderName, React.ReactNode> = {
	[FACEBOOK_PROVIDER_NAME]: <Icon name="facebook" />,
	[GITHUB_PROVIDER_NAME]: <Icon name="github-logo" />,
	[GOOGLE_PROVIDER_NAME]: <Icon name="google" />,
} as const

export const providerActionLabels: Record<
	'Connect' | 'Login' | 'Signup',
	string
> = {
	Login: 'Logg inn med',
	Signup: 'Registrer deg med',
	Connect: 'Kople til med',
} as const

export function ProviderDivider() {
	return (
		<div className="flex items-center justify-center gap-3 text-muted-foreground">
			<span className="h-px w-full bg-border" />
			<span className="whitespace-nowrap text-sm">eller</span>
			<span className="h-px w-full bg-border" />
		</div>
	)
}

export function ProviderConnectionForm({
	redirectTo,
	type,
	providerName,
}: {
	redirectTo?: string | null
	type: 'Connect' | 'Login' | 'Signup'
	providerName: ProviderName
}) {
	const label = providerLabels[providerName]
	const formAction = `/auth/${providerName}`
	const isPending = useIsPending({ formAction })
	return (
		<Form
			className="flex items-center justify-center gap-2"
			action={formAction}
			method="POST"
			// full document navigation: mock + real OAuth both set cookies on the
			// redirect chain, which browsers ignore for fetch (.data) submissions
			reloadDocument
		>
			{redirectTo ? (
				<input type="hidden" name="redirectTo" value={redirectTo} />
			) : null}
			<StatusButton
				type="submit"
				className="w-full"
				status={isPending ? 'pending' : 'idle'}
			>
				<span className="inline-flex items-center gap-1.5">
					{providerIcons[providerName]}
					<span>
						{providerActionLabels[type]} {label}
					</span>
				</span>
			</StatusButton>
		</Form>
	)
}
